export default "__VITE_PUBLIC_ASSET__73cd8a1e__"